import * as types from "./actionTypes";

const initialState = {
  singleproduct: [],
  cartItems: [],
  similarProducts: [],
  getcart: [],
  orderList: [],
  boughtTogetherProducts: [],
  isLoading: false,
  isLoadingai: false,
  isError: false,
  createorder: [],
  removecartitem: {},
  userProfile: null,
  makePayment: [],
  orderDataById: [],
  userAddressDataById: [],
  quantityData: [],
  suggestedProducts: [],
  addressData: [],
  isFetchingWishlistSuggestions: [],
  aigiftsData: [],
  allCat: [],
  subcatdata: [],
  plantSubCategory: [],
  checkPinCode: [],
  allTrendingProduct: [],
  allWishlist: [],
};

const prodReducer = (oldState = initialState, actionObj) => {
  const { type, payload } = actionObj;

  switch (type) {
    case types.UPDATE_QUANTITY:
      const { productId, variantId, quantity } = payload;

      const updatedQuantityData = oldState.quantityData.map((item) => {
        if (item.productId === productId && item.variantId === variantId) {
          return { ...item, quantity };
        }
        return item;
      });
      return {
        ...oldState,
        quantityData: updatedQuantityData,
      };

    // UPDATE_IS_IN_CART
    case types.UPDATE_IS_IN_CART:
      return {
        ...oldState,
        singleproduct: {
          ...oldState.singleproduct,
          isInCart: payload,
        },
      };

    // UPDATE_CART
    case types.UPDATE_CART:
      return {
        ...oldState,
        cartItems: payload,
      };

    // FETCH_LATEST_CART
    case types.FETCH_LATEST_CART:
      return {
        ...oldState,
        cartItems: payload,
      };

    //single Product
    case types.GET_SINGLE_PRODUCT_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_SINGLE_PRODUCT_SUCCESS:
      const product = payload;
      const cartItemExists = oldState.cartItems.find(
        (item) => item.productId === product.id
      );
      if (cartItemExists == null) {
        product.isInCart = false;
      }

      return { ...oldState, isLoading: false, singleproduct: product };

    case types.GET_SINGLE_PRODUCT_ERROR:
      return { ...oldState, isLoading: false, isError: true };

    //Addtocart
    case types.ADD_TO_CART_REQUEST:
      return { ...oldState, isLoading: true };
    case types.ADD_TO_CART_SUCCESS:
      return { ...oldState, isLoading: false, getcart: payload };
    case types.ADD_TO_CART_ERROR:
      return { ...oldState, isLoading: false, isError: true };

    //GetCart
    case types.GET_CART_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_CART_SUCCESS:
      return { ...oldState, isLoading: false, cartItems: payload };
    case types.GET_CART_ERROR:
      return { ...oldState, isLoading: false, isError: true };

    //SimilarProduct
    case types.GET_SIMILAR_PRODUCTS_REQUEST:
      return {
        ...oldState,
        isLoading: true,
        error: null,
      };
    case types.GET_SIMILAR_PRODUCTS_SUCCESS:
      return {
        ...oldState,
        similarProducts: payload,
      };
    case types.GET_SIMILAR_PRODUCTS_ERROR:
      return {
        ...oldState,
        isLoading: false,
        error: "An error occurred while fetching similar products.",
      };

    //Frequently Bought Together
    case types.GET_FREQUENTLY_BOUGHT_TOGETHER_REQUEST:
      return {
        ...oldState,
        isLoading: true,
        error: null,
      };
    case types.GET_FREQUENTLY_BOUGHT_TOGETHER_SUCCESS:
      return {
        ...oldState,
        boughtTogetherProducts: payload,
      };
    case types.GET_FREQUENTLY_BOUGHT_TOGETHER_ERROR:
      return {
        ...oldState,
        isLoading: false,
        error: "An error occurred while fetching similar products.",
      };

    // DELETE_ITEM_REQUEST
    case types.DELETE_ITEM_REQUEST:
      return {
        ...oldState,
        isLoading: true,
      };
    case types.DELETE_ITEM_SUCCESS:
      return {
        ...oldState,
        isLoading: false,
        removecartitem: payload,
      };
    case types.DELETE_ITEM_ERROR:
      return {
        ...oldState,
        isLoading: false,
        error: "An error occurred while updating cart item.",
      };

    // Create Order
    case types.CREATE_ORDER_REQUEST:
      return { ...oldState, isLoading: true };
    case types.CREATE_ORDER_SUCCESS:
      return { ...oldState, isLoading: false, createorder: payload };
    case types.CREATE_ORDER_ERROR:
      return { ...oldState, isLoading: false, isError: true };

    // GET_ORDER_LIST
    case types.GET_ORDER_LIST_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_ORDER_LIST_SUCCESS:
      return { ...oldState, isLoading: false, orderList: payload };

    case types.GET_ORDER_LIST_ERROR:
      return { ...oldState, isLoading: false, isError: true };

    // GET_USER_PROFILE_REQUEST
    case types.GET_USER_PROFILE_REQUEST:
      return { ...oldState, isLoading: true, isError: false };
    case types.GET_USER_PROFILE_SUCCESS:
      return {
        ...oldState,
        isLoading: false,
        userProfile: payload,
      };
    case types.GET_USER_PROFILE_ERROR:
      return { ...oldState, isLoading: false, isError: true };

    // Do Payment

    case types.POST_PAYMENT_REQUEST:
      return {
        ...oldState,
        isLoading: true,
      };
    case types.POST_PAYMENT_SUCCESS:
      return {
        ...oldState,
        isLoading: false,
        makePayment: payload,
      };
    case types.POST_PAYMENT_FAILURE:
      return {
        ...oldState,
        isLoading: false,
        error: true,
      };

    // GET_ORDER_BY_ID_REQUEST
    case types.GET_ORDER_BY_ID_REQUEST:
      return {
        ...oldState,
        isLoading: true,
        error: null,
      };

    case types.GET_ORDER_BY_ID_SUCCESS:
      return {
        ...oldState,
        isLoading: false,
        orderDataById: payload,
      };

    case types.GET_ORDER_BY_ID_ERROR:
      return {
        ...oldState,
        isLoading: false,
        error: true,
      };

    // GET_USER_ADDRESS_BY_ID_REQUEST
    case types.GET_USER_ADDRESS_BY_ID_REQUEST:
      return {
        ...oldState,
        loading: true,
        error: null,
      };

    case types.GET_USER_ADDRESS_BY_ID_SUCCESS:
      return {
        ...oldState,
        userAddressDataById: payload,
        loading: false,
        error: false,
      };

    case types.GET_USER_ADDRESS_BY_ID_ERROR:
      return {
        ...oldState,
        loading: false,
        error: true,
      };

    // GET_SUGGESTED_PRODUCTS
    case types.GET_SUGGESTED_PRODUCTS_REQUEST:
      return { ...oldState, isLoading: true, isError: false };
    case types.GET_SUGGESTED_PRODUCTS_SUCCESS:
      return {
        ...oldState,
        isLoading: false,
        suggestedProducts: payload,
      };
    case types.GET_SUGGESTED_PRODUCTS_ERROR:
      return { ...oldState, isLoading: false, isError: true };

    // addAddress
    case types.ADD_ADDRESS_REQUEST:
      return {
        ...oldState,
        isLoading: true,
        error: null,
      };
    case types.ADD_ADDRESS_SUCCESS:
      return {
        ...oldState,
        isLoading: false,
        addressData: payload,
      };
    case types.ADD_ADDRESS_FAILURE:
      return {
        ...oldState,
        isLoading: false,
        isError: true,
      };

    case types.FETCH_WISHLIST_SUGGESTIONS_REQUEST:
      return {
        ...oldState,
        isLoadingai: true,
        Error: false,
      };

    case types.FETCH_WISHLIST_SUGGESTIONS_SUCCESS:
      return {
        ...oldState,
        isLoadingai: false,
        isFetchingWishlistSuggestions: payload,
        error: false,
      };

    case types.FETCH_WISHLIST_SUGGESTIONS_ERROR:
      return {
        ...oldState,
        isLoadingai: false,
        error: true,
      };

    case types.FETCH_AIGIFTS_REQUEST:
      return {
        ...oldState,
        isLoading: true,
        isError: false,
      };

    case types.FETCH_AIGIFTS_SUCCESS:
      return {
        ...oldState,
        aigiftsData: payload,
        isError: false,
      };

    case types.FETCH_AIGIFTS_ERROR:
      return {
        ...oldState,
        isLoading: false,
        isError: true,
      };

    // Getallcatergorycards
    case "GET_ALL_CATEGORY_REQUEST":
      return {
        ...oldState,
        isLoading: true,
        error: null,
      };
    case "GET_ALL_CATEGORY_SUCCESS":
      return {
        ...oldState,
        allCat: payload,
        isLoading: false,
      };
    case "GET_ALL_CATEGORY_FAILURE":
      return {
        ...oldState,
        isLoading: false,
        isError: true,
      };

    // getgreeting subcat
    case types.GET_SUBCATEGORY_REQUEST:
      return {
        ...oldState,
        isLoading: true,
      };

    case types.GET_SUBCATEGORY_SUCCESS:
      return {
        ...oldState,
        isLoading: false,
        subcatdata: payload,
      };

    case types.GET_SUBCATEGORY_ERROR:
      return {
        ...oldState,
        isLoading: false,
        isError: true,
      };

    // get all trending products
    case types.GET_ALL_TRENDING_PRODUCT_REQUEST:
      return {
        ...oldState,
        isLoading: true,
      };

    case types.GET_ALL_TRENDING_PRODUCT_SUCCESS:
      return {
        ...oldState,
        isLoading: false,
        allTrendingProduct: payload,
      };

    case types.GET_ALL_TRENDING_PRODUCT_ERROR:
      return {
        ...oldState,
        isLoading: false,
        isError: true,
      };

    // get plant by sub category
    case types.GET_SUB_CATEGORY_PLANTS_REQUEST:
      return {
        ...oldState,
        isLoading: true,
      };

    case types.GET_SUB_CATEGORY_PLANTS_SUCCESS:
      return {
        ...oldState,
        isLoading: false,
        plantSubCategory: payload,
      };

    case types.GET_SUB_CATEGORY_PLANTS_ERROR:
      return {
        ...oldState,
        isLoading: false,
        isError: true,
      };

    // notify me
    case types.SEND_NOTIFY_REQUEST:
      return {
        ...oldState,
        isLoading: true,
      };

    case types.SEND_NOTIFY_SUCCESS:
      return {
        ...oldState,
        isLoading: false,
        productId: payload,
      };

    case types.SEND_NOTIFY_ERROR:
      return {
        ...oldState,
        isLoading: false,
        isError: true,
      };

    // get all wishlist
    case types.GET_ALL_WISHLIST_PRODUCT_REQUEST:
      return {
        ...oldState,
        isLoading: true,
      };

    case types.GET_ALL_WISHLIST_PRODUCT_SUCCESS:
      return {
        ...oldState,
        isLoading: false,
        allWishlist: payload,
      };

    case types.GET_ALL_WISHLIST_PRODUCT_ERROR:
      return {
        ...oldState,
        isLoading: false,
        isError: true,
      };

    // CHECK_PIN_CODE_AVAILABILITY
    case types.CHECK_PIN_CODE_AVAILABILITY_REQUEST:
      return {
        ...oldState,
        isLoading: true,
      };

    case types.CHECK_PIN_CODE_AVAILABILITY_SUCCESS:
      return {
        ...oldState,
        isLoading: false,
        checkPinCode: payload,
      };

    case types.CHECK_PIN_CODE_AVAILABILITY_ERROR:
      return {
        ...oldState,
        isLoading: false,
        isError: true,
        checkPinCode: {
          message: "Invalid Pin Code",
        },
      };
    case types.EMPTY_PIN_CODE_AVAILABILITY:
      return {
        ...oldState,
        isLoading: false,
        isError: false,
        checkPinCode: [],
      };

    default:
      return oldState;
  }
};

export { prodReducer };
